import {Component} from 'react';
import CareerInput from '../shared-components/career_input';

class CareerSelect extends Component {
  
    constructor(props) {
        super(props);
        props.onOpen();
        this.inputSelected = (inputID) => {
           
        };
        this.state = {
  
        }
        
        this.inputSelected(1);
    }    

    render() {
     
    return <>
            <CareerInput 
                onOpen ={()=> this.inputSelected(1)} 
                onSelected={() => this.onCareerSelected()}
                currentJobName={""}
                processError = {(errorObj) => this.props.processError(errorObj)} />
    </>
    }

    onCareerSelected() {
        this.props.completed();
        this.props.onNavigate("choose-home");
    }

}
export default CareerSelect;